import React, { useState } from 'react';
import { Input, Textarea, Button, Dialog } from "@material-tailwind/react";
import { db, storage } from '../firebase.config';
import { collection, addDoc } from 'firebase/firestore';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import Sidebar from '../component/Sidebar';
import { useNavigate  } from 'react-router-dom';

const InstructorAccountCreator = () => {
  const [instructorName, setInstructorName] = useState('');
  const [shortDesc, setShortDesc] = useState('');
  const [subHeading, setSubHeading] = useState('');
  const [aboutDesc, setAboutDesc] = useState('');
  const [instructorLocation, setInstructorLocation] = useState('');
  const [instructorEmail, setInstructorEmail] = useState('');
  const [instructorPhone, setInstructorPhone] = useState('');
  const [instructorTwitterURL, setInstructorTwitterURL] = useState('');
  const [instructorFacebookURL, setInstructorFacebookURL] = useState('');
  const [instructorInstagramURL, setInstructorInstagramURL] = useState('');
  const [instructorEnglish, setInstructorEnglish] = useState('');
  const [instructorHindi, setInstructorHindi] = useState('');
  const [instructorProfile, setInstructorProfile] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [instructorLink, setInstructorLink] = useState('');
  const navigate = useNavigate();

  const handleNewInstructor = async (
    instructorName,
    shortDesc,
    subHeading,
    aboutDesc,
    instructorLocation,
    instructorEmail,
    instructorPhone,
    instructorTwitterURL,
    instructorFacebookURL,
    instructorInstagramURL,
    instructorEnglish,
    instructorHindi
  ) => {
    try {
      // Generate a unique file name for the instructor profile
      const timestamp = new Date().getTime();
      const uniqueFileName = `${instructorProfile.name}_${timestamp}`;

      // Upload the instructor profile file to Firebase Storage
      const profileRef = ref(storage, `instructor_profiles/${uniqueFileName}`);
      const uploadTask = uploadBytesResumable(profileRef, instructorProfile);

      uploadTask.on(
        'state_changed',
        null,
        (error) => {
          console.error('Error uploading instructor profile:', error);
        },
        async () => {
          const profileUrl = await getDownloadURL(uploadTask.snapshot.ref);

          // Add the instructor data to Firestore, including the profile URL and additional fields
          const instRef = collection(db, 'instructors');
          const docRef = await addDoc(instRef, {
            name: instructorName,
            shortDesc,
            subHeading,
            aboutDesc,
            instructorLocation,
            instructorEmail,
            instructorPhone,
            instructorTwitterURL,
            instructorFacebookURL,
            instructorInstagramURL,
            instructorEnglish,
            instructorHindi,
            profileUrl
          });

          // Get the unique ID of the new instructor document
          const instructorId = docRef.id;

          // Construct the instructor link with the ID
          const instructorLink = `/instructor/${instructorId}`;
          setInstructorLink(instructorLink);
          setShowDialog(true);

          // Clear the input fields after successful submission
          setInstructorName('');
          setShortDesc('');
          setSubHeading('');
          setAboutDesc('');
          setInstructorLocation('');
          setInstructorEmail('');
          setInstructorPhone('');
          setInstructorTwitterURL('');
          setInstructorFacebookURL('');
          setInstructorInstagramURL('');
          setInstructorEnglish('');
          setInstructorHindi('');
          setInstructorProfile(null);
          console.log('Instructor added successfully!');
        }
      );
    } catch (error) {
      console.error('Error adding instructor:', error);
    }
  };

  const submitInstructor = (e) => {
    e.preventDefault();
    if (instructorName.trim() === '' || shortDesc.trim() === '' || !instructorProfile) {
      console.log('Please fill in all fields and upload an instructor profile.');
      return;
    }

    handleNewInstructor(
      instructorName,
      shortDesc,
      subHeading,
      aboutDesc,
      instructorLocation,
      instructorEmail,
      instructorPhone,
      instructorTwitterURL,
      instructorFacebookURL,
      instructorInstagramURL,
      instructorEnglish,
      instructorHindi
    );
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    navigate('/'); // Redirect to the desired page after closing the dialog
  };

  return (
    <div className="flex relative dark:bg-main-dark-bg">
      <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white dark:bg-main-bg bg-main-bg min-h-screen">
        <Sidebar />
      </div>
      

      <div className="ml-72 flex-1 dark:bg-main-dark-bg bg-main-bg min-h-screen">
        <div className="flex justify-left items-center mt-20">
          <div className="w-full md:w-1/2 px-4">
          <div className="mb-4 text-align:center">
              <h1>Create Instructor Account</h1>
            </div>
            <div className="mb-4">
              <Input
                label="Instructor Name"
                value={instructorName}
                onChange={(e) => setInstructorName(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <Input
                label="Sub Heading"
                value={subHeading}
                onChange={(e) => setSubHeading(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <Textarea
                label="Short Description"
                value={shortDesc}
                onChange={(e) => setShortDesc(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <Textarea
                label="Personal Statement"
                value={aboutDesc}
                onChange={(e) => setAboutDesc(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <Input
                label="Location"
                value={instructorLocation}
                onChange={(e) => setInstructorLocation(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <Input
                label="Email"
                value={instructorEmail}
                onChange={(e) => setInstructorEmail(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <Input
                label="Phone"
                value={instructorPhone}
                onChange={(e) => setInstructorPhone(e.target.value)}
              />
            </div>
            <h1>Social Media</h1>
            <div className="mb-4">
              <Input
                label="Twitter Profile"
                value={instructorTwitterURL}
                onChange={(e) => setInstructorTwitterURL(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <Input
                label="Facebook Profile"
                value={instructorFacebookURL}
                onChange={(e) => setInstructorFacebookURL(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <Input
                label="Instagram Profile"
                value={instructorInstagramURL}
                onChange={(e) => setInstructorInstagramURL(e.target.value)}
              />
            </div>

            <h1>Personal Language Skill</h1>

            <div className="mb-4">
              <Input
                label="English"
                value={instructorEnglish}
                onChange={(e) => setInstructorEnglish(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <Input
                label="Hindi"
                value={instructorHindi}
                onChange={(e) => setInstructorHindi(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <Input
                type="file"
                label="Instructor Profile"
                onChange={(e) => setInstructorProfile(e.target.files[0])}
              />
            </div>
            <div className="mb-4 mt-5" type="submit" onClick={submitInstructor}>
              <Button variant="filled">Add Instructor</Button>
            </div>
          </div>
        </div>
      </div>

      {/* Dialog for displaying the instructor link */}
      <Dialog open={showDialog} handler={handleCloseDialog}>
        <div className="flex flex-col items-center">
          <h2 className="mb-4">Instructor Link</h2>
          <p className="mb-4">
            Copy the following link and share it with the instructor:
          </p>
          <input
            type="text"
            value={instructorLink}
            readOnly
            className="mb-4 px-4 py-2 border border-gray-300 rounded"
          />
          <Button variant="filled" onClick={() => navigator.clipboard.writeText(instructorLink)}>
            Copy Link
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default InstructorAccountCreator;